import { useTranslation } from 'react-i18next'
import { OreStack, OreText } from '@edenredespana/oreneta'
import { ErrorModal } from './ErrorModal'
import { useState } from 'react'
import { storesTranslation } from '../storesTranslation'
import { InsertResultResponse } from '@/Store/domain'

export const TPVStatusPill = ({ tpv }: { tpv: InsertResultResponse }): JSX.Element => {
  const { t } = useTranslation()
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)

  const getPillText = (isSuccess?: boolean) => {
    switch (isSuccess) {
      case true:
        return <OreText tone="success-600">{t(storesTranslation.excelTPVConfirmation.completeStatus)}</OreText>
      case false:
        return <OreStack direction="row" placeContent="start" space="2xsmall">
          <OreText tone="error-600">{t(storesTranslation.excelTPVConfirmation.failedStatus)}</OreText>
          <button
            type="button"
            onClick={() => setIsErrorModalOpen(true)}
            style={{ color: '#B60C00', textDecoration: 'underline', cursor: 'pointer', font: 'inherit', background: 'none', border: 0, padding: 0 }}>
            {t(storesTranslation.excelTPVConfirmation.seeError)}
          </button>
        </OreStack>
      default:
        return ""
    }
  }

  return (
    <>
      <OreStack 
      placeItems="start"
      style={{
         backgroundColor: tpv.isSuccess ? '#E0F6E6' : '#FFDDD8',
         borderRadius: '100px',
         padding: '4px 12px',
        width: 'fit-content',
        maxWidth: '100%',
       }}>
        <OreText tone={tpv.isSuccess ? 'success-600' : 'error-600'}>
          {getPillText(tpv.isSuccess)}
        </OreText>
      </OreStack>
      <ErrorModal tpv={tpv} isOpen={isErrorModalOpen} onClose={() => setIsErrorModalOpen(false)} />
    </>
  )
}
